export default {
    edition() {
        return $("body").data("edition-id") || "de";
    },
    lang() {
        return $("html").attr("lang") || "de";
    }
}



// WEBPACK FOOTER //
// ./js/utils/I18n.js